export type PartnerAuthHeaders = {
  "x-partner-id": string;
  "x-partner-apikey": string;
};

export type PartnerAuthOverride = {
  partnerId?: string;
  partnerApiKey?: string;
};

let hostOverride: PartnerAuthHeaders | null = null;

/**
 * Partner enviado por el host al montar el widget (plantilla PDF por cliente).
 * Solo aplica si llegan ambos valores; si no, se usa el partner del build.
 */
export const setPartnerAuthOverride = (
  override: PartnerAuthOverride | undefined,
): void => {
  const partnerId = override?.partnerId?.trim();
  const partnerApiKey = override?.partnerApiKey?.trim();
  hostOverride =
    partnerId && partnerApiKey
      ? { "x-partner-id": partnerId, "x-partner-apikey": partnerApiKey }
      : null;
};

/**
 * Headers partner para notify y PDFs (cotización y póliza).
 * Prioridad: override del host, luego `VITE_KC_PARTNER_ID` / `VITE_KC_PARTNER_APIKEY` en build.
 */
export const getPartnerAuthHeaders = (): PartnerAuthHeaders | null => {
  if (hostOverride) return { ...hostOverride };
  const partnerId = import.meta.env.VITE_KC_PARTNER_ID?.trim();
  const partnerApiKey = import.meta.env.VITE_KC_PARTNER_APIKEY?.trim();
  if (!partnerId || !partnerApiKey) return null;
  return {
    "x-partner-id": partnerId,
    "x-partner-apikey": partnerApiKey,
  };
};

export const requirePartnerAuthHeaders = (): PartnerAuthHeaders => {
  const headers = getPartnerAuthHeaders();
  if (!headers) {
    throw new Error(
      "Credenciales de partner no configuradas (VITE_KC_PARTNER_ID / VITE_KC_PARTNER_APIKEY)",
    );
  }
  return headers;
};
